import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from '../AuthContext';
import "./AdminAddProduct.css";
import Swal from 'sweetalert2';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AdminEditRedeemableProduct() {
  const { id } = useParams();
  const { authFetch } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [mainImageFile, setMainImageFile] = useState(null);
  const [mainImagePreview, setMainImagePreview] = useState(null);
  const [hasExistingImage, setHasExistingImage] = useState(false);
  const [additionalImages, setAdditionalImages] = useState([]);
  const [imageUpdates, setImageUpdates] = useState({
    updated: false,
    removeImageIds: [],
    setMainImageId: null
  });
  const MAX_ADDITIONAL_IMAGES = 4;

  const [category, setCategory] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [categories, setCategories] = useState([]);
  //const [stockQuantityModified, setStockQuantityModified] = useState(false);
  //const [batchStockQuantityModified, setBatchStockQuantityModified] = useState(false);

  const [product, setProduct] = useState({
    name: "",
    description: "",
    categoryID: "",
    stockQuantity: null,
    batchStockQuantity: null,
    pointsRequired: null,
    redeemQuantity: 1,
    productCode: "",
    mainImageUrl: null,
    additionalImages: [],
    uom: "",
  });

  const validateRedeemableProduct = () => {
    if (!product.pointsRequired || product.pointsRequired <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Points Required',
        text: 'Points required must be greater than 0.',
        confirmButtonColor: '#e74c3c'
      });
      return false;
    }

    if (product.stockQuantity === "" || parseInt(product.stockQuantity) < 0) {
      Swal.fire({
        icon: 'error',
        title: 'Stock Quantity Required',
        text: 'Redeemable products must have stock quantity set.',
        confirmButtonColor: '#e74c3c'
      });
      return false;
    }

    // UOM is optional - no validation needed.

    // if (product.batchStockQuantity === "" || parseInt(product.batchStockQuantity) < 0) {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Batch Stock Quantity Required',
    //     text: 'Redeemable products must have batch stock quantity set.',
    //     confirmButtonColor: '#e74c3c'
    //   });
    //   return false;
    // }

    // if (product.stockQuantity > product.batchStockQuantity) {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Invalid Stock Quantity',
    //     text: 'Current stock quantity cannot exceed batch stock quantity.',
    //     confirmButtonColor: '#e74c3c'
    //   });
    //   return false;
    // }

    return true;
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/products/${id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch product");
        }
        const data = await response.json();
        setProduct(data);
        setIsActive(data.isActive ?? true);
        setCategory(data.categoryID);

        if (data.mainImageUrl) {
          setMainImagePreview(`${data.mainImageUrl}`);
          setHasExistingImage(true);
        }

        if (data.additionalImages && data.additionalImages.length > 0) {
          const additionalImagesData = data.additionalImages.map(img => ({
            id: img.imageId,
            preview: `${img.imageUrl}`,
            displayOrder: img.displayOrder,
            isExisting: true
          }));

          setAdditionalImages(additionalImagesData);
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/products/categories`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        const filteredCategories = data.filter(category => !category.hasSubcategories);
        setCategories(filteredCategories);
      } catch (error) {
        // Silent fail
      }
    };

    fetchProduct();
    fetchCategories();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let parsedValue = value;
    if (name === 'stockQuantity' || name === 'pointsRequired' || name === 'redeemQuantity') {
      parsedValue = value === '' ? null : parseInt(value);
    }

    if (name === 'stockQuantity') {
      //setStockQuantityModified(true);

      setProduct(prev => {
        const newState = { ...prev, stockQuantity: parsedValue };

        // setTimeout(() => {
        //   const element = document.getElementById('stockQuantity');
        //   if (parsedValue !== null && prev.batchStockQuantity !== null && parsedValue > prev.batchStockQuantity) {
        //     element?.classList.add('admin-edit-product-input-warning');
        //   } else {
        //     element?.classList.remove('admin-edit-product-input-warning');
        //   }
        // }, 0);

        return newState;
      });
    }
    // else if (name === 'batchStockQuantity') {
    //   setBatchStockQuantityModified(true);

    //   setProduct(prev => {
    //     const newState = { ...prev, batchStockQuantity: parsedValue };
    //     setTimeout(() => {
    //       const stockField = document.getElementById('stockQuantity');
    //       if (prev.stockQuantity !== null && parsedValue !== null && prev.stockQuantity > parsedValue) {
    //         stockField?.classList.add('admin-edit-product-input-warning');
    //       } else {
    //         stockField?.classList.remove('admin-edit-product-input-warning');
    //       }
    //     }, 0);
    //     return newState;
    //   });
    // }
    else {
      setProduct(prev => ({ ...prev, [name]: parsedValue }));
    }
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: 'error',
          title: 'File Too Large',
          text: 'Please select an image under 5MB.',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }
      const extension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      if (!allowedExtensions.includes(extension)) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid File Type',
          text: 'Please select a valid image file (JPG, JPEG, PNG only).',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }

      setMainImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setMainImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClearMainImage = () => {
    Swal.fire({
      title: 'Remove Main Image?',
      text: 'Are you sure you want to remove this image?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#e74c3c',
      cancelButtonColor: '#7a7a7a',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        setMainImageFile(null);
        setMainImagePreview(null);
        setHasExistingImage(false);
        setImageUpdates(prev => ({ ...prev, updated: true }));
      }
    });
  };

  const handleAdditionalImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    if (additionalImages.length + files.length > MAX_ADDITIONAL_IMAGES) {
      Swal.fire({
        icon: 'warning',
        title: 'Too Many Images',
        text: `You can upload a maximum of ${MAX_ADDITIONAL_IMAGES} additional images.`,
        confirmButtonColor: '#e74c3c'
      });
      return;
    }

    for (const file of files) {
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: 'error',
          title: 'File Too Large',
          text: 'Please select images under 5MB.',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }

      const extension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      if (!allowedExtensions.includes(extension)) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid File Type',
          text: 'Please select valid image files (JPG, JPEG, PNG only).',
          confirmButtonColor: '#e74c3c'
        });
        return;
      }
    }

    const newImages = [];

    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newImages.push({
          file,
          preview: reader.result,
          displayOrder: additionalImages.length + newImages.length + 1,
          isNew: true
        });

        if (newImages.length === files.length) {
          const combinedImages = [...additionalImages, ...newImages];

          combinedImages.forEach((img, i) => {
            img.displayOrder = i + 1;
          });

          setAdditionalImages(combinedImages);
          setImageUpdates(prev => ({ ...prev, updated: true }));
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemoveAdditionalImage = (index) => {
    Swal.fire({
      title: 'Remove Image?',
      text: 'Are you sure you want to remove this image?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#e74c3c',
      cancelButtonColor: '#7a7a7a',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        const imageToRemove = additionalImages[index];

        if (imageToRemove.id && !imageToRemove.isNew) {
          setImageUpdates(prev => ({
            ...prev,
            updated: true,
            removeImageIds: [...prev.removeImageIds, imageToRemove.id]
          }));
        }

        const newImages = [...additionalImages];
        newImages.splice(index, 1);

        newImages.forEach((img, i) => {
          img.displayOrder = i + 1;
        });

        setAdditionalImages(newImages);
        setImageUpdates(prev => ({ ...prev, updated: true }));
      }
    });
  };

  const moveAdditionalImage = (index, direction) => {
    if ((direction === 'up' && index === 0) ||
      (direction === 'down' && index === additionalImages.length - 1)) {
      return;
    }

    const newImages = [...additionalImages];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    [newImages[index], newImages[targetIndex]] = [newImages[targetIndex], newImages[index]];

    newImages.forEach((img, i) => {
      img.displayOrder = i + 1;
    });

    setAdditionalImages(newImages);
    setImageUpdates(prev => ({ ...prev, updated: true }));
  };

  const handleSetAsMainImage = (index) => {
    Swal.fire({
      title: 'Set as Main Image?',
      text: 'Are you sure you want to set this as the main product image?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3498db',
      cancelButtonColor: '#7a7a7a',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        const imageToSetAsMain = additionalImages[index];

        const oldMainImagePreview = mainImagePreview;

        setMainImagePreview(imageToSetAsMain.preview);
        setMainImageFile(imageToSetAsMain.file || null);
        setHasExistingImage(true);

        if (imageToSetAsMain.id && !imageToSetAsMain.isNew) {
          setImageUpdates(prev => ({
            ...prev,
            updated: true,
            setMainImageId: imageToSetAsMain.id
          }));
        }

        const newImages = [...additionalImages];
        newImages.splice(index, 1);

        if (oldMainImagePreview && hasExistingImage) {
          newImages.push({
            preview: oldMainImagePreview,
            displayOrder: newImages.length + 1,
            isFromMain: true
          });
        }

        newImages.forEach((img, i) => {
          img.displayOrder = i + 1;
        });

        setAdditionalImages(newImages);
        setImageUpdates(prev => ({ ...prev, updated: true }));
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!mainImageFile && !hasExistingImage) {
      Swal.fire({
        icon: 'error',
        title: 'Image Required',
        text: 'A product must have an image. Please upload an image.',
        confirmButtonColor: '#e74c3c'
      });
      return;
    }

    if (!validateRedeemableProduct()) {
      return;
    }

    Swal.fire({
      title: 'Saving Changes',
      text: 'Please wait...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const formData = new FormData();
      formData.append("Name", product.name);
      formData.append("Description", product.description);
      formData.append("CategoryID", category);
      formData.append("StockQuantity", product.stockQuantity);
      //formData.append("BatchStockQuantity", product.batchStockQuantity);
      formData.append("MOQ", "1");
      formData.append("ProductCode", product.productCode);
      formData.append("IsRedeemable", true);
      formData.append("PointsRequired", product.pointsRequired);
      formData.append("IsActive", isActive);
      formData.append("RedeemQuantity", product.redeemQuantity || 1);
      formData.append("UOM", product.uom ?? "");
      if (imageUpdates.updated) {
        formData.append("UpdateImages", "true");

        if (mainImageFile) {
          formData.append("ImageFile", mainImageFile);
        }

        const newAdditionalImages = additionalImages
          .filter(img => img.isNew && img.file)
          .sort((a, b) => a.displayOrder - b.displayOrder);

        newAdditionalImages.forEach(img => {
          formData.append("AdditionalImageFiles", img.file);
        });

        newAdditionalImages.forEach((img, index) => {
          formData.append(`NewImageDisplayOrders[${index}]`, img.displayOrder);
        });

        if (imageUpdates.removeImageIds.length > 0) {
          imageUpdates.removeImageIds.forEach((id, index) => {
            formData.append(`RemoveImageIds[${index}]`, id);
          });
        }

        const existingImages = additionalImages.filter(img => img.id && !img.isNew);
        existingImages.forEach((img, index) => {
          formData.append(`ImageDisplayOrders[${index}].ImageId`, img.id);
          formData.append(`ImageDisplayOrders[${index}].DisplayOrder`, img.displayOrder);
        });

        if (imageUpdates.setMainImageId) {
          formData.append("SetMainImageId", imageUpdates.setMainImageId);
        }
      }
      else if (mainImageFile) {
        formData.append("ImageFile", mainImageFile);
      }

      formData.append("UpdateSpecifications", "false");
      formData.append("UpdateVariants", "false");

      const response = await authFetch(`${API_BASE_URL}/products/${id}`, {
        method: "PUT",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to update redeemable product");
      }

      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Redeemable product updated successfully',
        confirmButtonColor: '#45a049'
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      setError(error);

      Swal.fire({
        icon: 'error',
        title: 'Update Failed',
        text: 'Failed to update redeemable product: ' + error.message,
        confirmButtonColor: '#e74c3c'
      });
    }
  };

  const handleBack = () => {
    navigate("/admin/products/redeemable");
  };

  const handleRemoveProduct = async () => {
    const result = await Swal.fire({
      title: 'Remove Redeemable Product',
      text: 'Are you sure you want to remove this redeemable product?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e74c3c',
      cancelButtonColor: '#7a7a7a',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          title: 'Removing Redeemable Product',
          text: 'Please wait...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const formData = new FormData();
        formData.append("Name", product.name);
        formData.append("Description", product.description);
        formData.append("CategoryID", category);
        formData.append("StockQuantity", product.stockQuantity);
        //formData.append("BatchStockQuantity", product.batchStockQuantity);
        formData.append("MOQ", "1");
        formData.append("ProductCode", product.productCode);
        formData.append("IsRedeemable", true);
        formData.append("PointsRequired", product.pointsRequired);
      formData.append("IsActive", isActive);
        formData.append("RedeemQuantity", product.redeemQuantity || 1);

        if (mainImageFile) {
          formData.append("ImageFile", mainImageFile);
        }
        formData.append("deletedAt", new Date().toISOString());
        formData.append("updateSpecifications", "false");
        formData.append("updateVariants", "false");
        formData.append("UOM", product.uom ?? "");
        const response = await authFetch(
          `${API_BASE_URL}/products/${id}`,
          {
            method: "PUT",
            body: formData,
          }
        );

        if (response.ok) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Redeemable product removed successfully',
            timer: 1500,
            confirmButtonColor: '#45a049'
          }).then(() => {
            navigate("/admin/products/redeemable");
          });
        } else {
          throw new Error("Failed to remove redeemable product");
        }
      } catch (error) {
        setError(error);
        Swal.fire({
          icon: 'error',
          title: 'Removal Failed',
          text: 'Failed to remove redeemable product: ' + error.message,
          confirmButtonColor: '#e74c3c'
        });
      }
    }
  };

  if (loading) {
    return (
      <div className="admin-add-product-container">
        <div className="admin-edit-product-loading">
          <div className="admin-edit-product-loading-spinner">
            <i className="fas fa-spinner fa-spin"></i>
          </div>
          <p>Loading redeemable product details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-add-product-container">
        <div className="admin-edit-product-error">
          <i className="fas fa-exclamation-circle"></i> Error: {error.message}
        </div>
        <button className="admin-add-product-back-btn" onClick={handleBack}>
          <i className="fas fa-arrow-left"></i> Back to Products
        </button>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="admin-add-product-container">
        <div className="admin-edit-product-error">
          <i className="fas fa-exclamation-triangle"></i> Redeemable product not found
        </div>
        <button className="admin-add-product-back-btn" onClick={handleBack}>
          <i className="fas fa-arrow-left"></i> Back to Products
        </button>
      </div>
    );
  }

  return (
    <div className="admin-add-product-container">
      {/* Back to Product */}
      <div className="admin-add-product-header">
        <button className="admin-add-product-back-btn" onClick={handleBack}>
          <i className="fas fa-arrow-left"></i> Back to Products
        </button>
      </div>

      <div className="admin-add-product-title">
        <h1>Edit Redeemable Product</h1>
      </div>

      <form onSubmit={handleSubmit} className="admin-add-product-details-form">
        <div className="admin-add-product-form-group">
          <label>Name:</label>
          <input
            type="text"
            name="name"
            value={product.name || ""}
            onChange={handleChange}
            placeholder="Product name"
            required
          />
        </div>
        <div className="admin-add-product-form-group">
          <label>Category:</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">Select a category</option>
            {categories.map((cat) => (
              <option key={cat.categoryID} value={cat.categoryID}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="admin-add-product-form-group">
          <label>Product Code:</label>
          <input
            type="text"
            name="productCode"
            value={product.productCode ?? ""}
            onChange={handleChange}
            placeholder="Product code"
            required
          />
        </div>
        <div className="admin-edit-product-form-group">
            <label>Product UOM:</label>
            <input
              type="text"
              name="uom"
              value={product.uom ?? ""}
              onChange={handleChange}
            />
          </div>

          {/* Storefront visibility */}
          <div className="admin-edit-product-form-group" style={{ textAlign: 'left' }}>
            <label style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
              Active (show on website): <input
                type="checkbox"
                name="isActive"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
            </label>
            <small style={{ display: 'block', marginTop: '4px', color: '#777' }}>
              Uncheck to hide this product from customers. It stays here in the back office.
            </small>
          </div>
        <div className="admin-edit-product-form-group">
          <label>Description:</label>
          <textarea
            name="description"
            value={product.description || ""}
            onChange={handleChange}
            placeholder="Product description"
            required
          />
        </div>

        <div className="admin-add-product-form-group">
          <label>Points Required:</label>
          <input
            type="number"
            name="pointsRequired"
            value={product.pointsRequired ?? ""}
            onChange={handleChange}
            placeholder="Points required per redemption"
            required
            min="1"
          />
          <small className="admin-edit-product-help-text">
            Points required for ONE redemption (one bundle).
          </small>
        </div>

        <div className="admin-add-product-form-group">
          <label>Redeem Quantity (units per redemption):</label>
          <input
            type="number"
            name="redeemQuantity"
            value={product.redeemQuantity ?? 1}
            onChange={handleChange}
            placeholder="e.g. 50"
            required
            min="1"
          />
          <small className="admin-edit-product-help-text">
            How many units the customer receives for one redemption. e.g. 2,500 points = 50 units.
          </small>
        </div>

        {/* <div className="admin-add-product-form-group">
          <label>Batch Stock Quantity:</label>
          <input
            id="batchStockQuantity"
            type="number"
            name="batchStockQuantity"
            value={product.batchStockQuantity ?? ""}
            onChange={handleChange}
            placeholder="Batch stock quantity"
            required
            min="0"
          />
          <small className="admin-edit-product-help-text">
            Stock quantity of one batch.
          </small>
        </div> */}
        <div className="admin-add-product-form-group">
          <label>Current Stock Quantity:</label>
          <input
            id="stockQuantity"
            type="number"
            name="stockQuantity"
            value={product.stockQuantity ?? ""}
            onChange={handleChange}
            placeholder="Current stock quantity"
            required
            min="0"
          />
          {/* {product.stockQuantity !== null && product.batchStockQuantity !== null && product.stockQuantity > product.batchStockQuantity && (
            <small className="admin-edit-product-warning-text">
              Warning: Stock quantity exceeds batch stock quantity
            </small>
          )} */}
        </div>

        {/* Product Images Section */}
        <div className="admin-add-product-form-group">
          <label>Product Images:</label>
          <div className="admin-add-product-images-row">
            {/* Main Image Section */}
            <div className="admin-add-product-main-image-section">
              <div className="admin-add-product-main-image-label">Main Image</div>
              <div className="admin-add-product-image-item">
                <label htmlFor="productMainImageUpload">
                  {mainImagePreview ? (
                    <div className="admin-add-product-image-card">
                      <img src={mainImagePreview} alt="Main Product Preview" />
                      <div className="admin-add-product-image-order-badge">1</div>
                    </div>
                  ) : (
                    <div className="admin-add-product-image-card">
                      <div className="admin-add-product-upload-placeholder">
                        <i className="fas fa-cloud-upload-alt"></i>
                        <div className="admin-add-product-upload-text">
                          <span>Main Image</span>
                          <span className="admin-add-product-upload-subtext">Max 5MB</span>
                        </div>
                      </div>
                    </div>
                  )}
                  <input
                    id="productMainImageUpload"
                    type="file"
                    accept="image/*"
                    onChange={handleMainImageChange}
                    style={{ display: 'none' }}
                  />
                </label>
                {mainImagePreview && (
                  <div className="admin-add-product-image-actions-visible">
                    <button
                      type="button"
                      className="admin-add-product-delete"
                      onClick={handleClearMainImage}
                      title="Remove image"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Divider */}
            <div className="admin-add-product-image-divider"></div>

            {/* Additional Images Section */}
            <div className="admin-add-product-additional-images-section">
              <div className="admin-add-product-additional-images-label">Additional Images (up to {MAX_ADDITIONAL_IMAGES})</div>
              <div className="admin-add-product-additional-images-container">
                {/* Display additional images */}
                {additionalImages.map((img, index) => (
                  <div key={index} className="admin-add-product-image-item">
                    <div className="admin-add-product-image-card">
                      <img src={img.preview} alt={`Additional ${index + 1}`} />
                      <div className="admin-add-product-image-order-badge">{index + 2}</div>
                    </div>
                    <div className="admin-add-product-image-actions-visible">
                      <button
                        type="button"
                        className="admin-add-product-edit"
                        onClick={() => moveAdditionalImage(index, 'up')}
                        disabled={index === 0}
                        title="Move up"
                      >
                        <i className="fas fa-arrow-up"></i>
                      </button>
                      <button
                        type="button"
                        className="admin-add-product-edit"
                        onClick={() => moveAdditionalImage(index, 'down')}
                        disabled={index === additionalImages.length - 1}
                        title="Move down"
                      >
                        <i className="fas fa-arrow-down"></i>
                      </button>
                      <button
                        type="button"
                        className="admin-add-product-edit"
                        onClick={() => handleSetAsMainImage(index)}
                        title="Set as main image"
                      >
                        <i className="fas fa-star"></i>
                      </button>
                      <button
                        type="button"
                        className="admin-add-product-delete"
                        onClick={() => handleRemoveAdditionalImage(index)}
                        title="Remove image"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                ))}

                {/* Upload additional image button */}
                {additionalImages.length < MAX_ADDITIONAL_IMAGES && (
                  <div className="admin-add-product-image-item">
                    <label htmlFor="additionalImageUpload">
                      <div className="admin-add-product-image-card">
                        <div className="admin-add-product-upload-placeholder">
                          <i className="fas fa-plus"></i>
                          <div className="admin-add-product-upload-text">
                            <span>Add Image</span>
                            <span className="admin-add-product-upload-subtext">Max 5MB</span>
                          </div>
                        </div>
                      </div>
                    </label>
                    <input
                      id="additionalImageUpload"
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleAdditionalImageChange}
                      style={{ display: 'none' }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <button type="submit" className="admin-add-product-btn-primary" disabled={!product.name?.trim()}>
          <i className="fas fa-save"></i> Save Changes
        </button>
      </form>

      {/* Action Buttons */}
      <div className="admin-edit-product-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', margin: '30px 0' }}>
        <button
          type="button"
          className="admin-add-product-back-btn"
          onClick={handleRemoveProduct}
          style={{ backgroundColor: '#e74c3c' }}
        >
          <i className="fas fa-trash-alt"></i> Remove Product
        </button>
      </div>
    </div>
  );
}

export default AdminEditRedeemableProduct;